import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Sidebar } from 'primereact/sidebar';
import { useEffect, useState } from 'react';
import FormInput from '../../../../components/Form/FormInput';
import RichTextEditor from '../../../../components/Form/RichTextEditor';
import { InputNumber } from 'primereact/inputnumber';
import { ToggleButton } from 'primereact/togglebutton';
import ImageForm from '../../common/image/ImageForm';
import PropertyField from '../../../../components/Properties/PropertyField';
import { CONSTANT } from '../../../../utils/constants';
import { Dropdown } from 'primereact/dropdown';
import Tag from '../../../../components/Display/Tag';

function PropertyPanel({ isOpen, onClose, property, loading, onUpdate, onCreate }) {
  const [title, setTitle] = useState('');
  const [dept, setDept] = useState('');
  const [surface, setSurface] = useState(null);
  const [price, setPrice] = useState(null);
  const [availabilty, setAvailabilty] = useState(false);
  const [description, setDescription] = useState('');
  const [sold, setSold] = useState(false);
  const [highlights, setHighlights] = useState([]);
  const [mainImg, setMainImg] = useState(undefined);
  const [isDraft, setIsDraft] = useState(true);

  useEffect(() => {
    if (property) {
      setTitle(property.title);
      setDept(property.dept);
      setSurface(property.surface);
      setPrice(property.price);
      setAvailabilty(property.availabilty);
      setSold(property.sold);
      setHighlights(property?.highlights?.map((h) => h.id));
      setMainImg(property.main_img);
      setDescription(property.description);
      setIsDraft(property.is_draft);
    } else {
      setTitle('');
      setDept('');
      setSurface(undefined);
      setPrice(undefined);
      setAvailabilty(false);
      setSold(false);
      setHighlights([]);
      setMainImg(undefined);
      setDescription('');
      setIsDraft(true);
    }
  }, [property, isOpen]);

  const handleValidate = () => {
    const propertyPayload = {
      title,
      dept,
      surface,
      price,
      availabilty,
      sold,
      highlights,
      main_img: mainImg?.id,
      description,
      is_draft: isDraft
    };
    property ? onUpdate(propertyPayload) : onCreate(propertyPayload);
  };

  const formIsValid = () => {
    return title && description.length && dept && surface && price && mainImg;
  };

  const footerButtons = (
    <div className="manage-footer">
      <Button
        key={'validate'}
        label={`Valider la ${property ? 'modification' : 'création'}`}
        className="w-full"
        onClick={handleValidate}
        severity="success"
        disabled={!formIsValid()}
        loading={loading}
      />
    </div>
  );

  const statusTemplate = (option) => <Tag tag={{ label: option.label, bgColor: option.bgColor }} />;

  return (
    <Sidebar
      style={{ width: 700 }}
      visible={isOpen}
      position="right"
      onHide={() => onClose(false)}
      header={
        <h3 className="text-slate-800 text-2xl font-medium">{`${property ? 'Modifier' : 'Ajouter'} une propriété`}</h3>
      }>
      <div className="sidebar-content-container">
        <div className="form-wrapper !pb-60">
          <FormInput label={'Titre de la propriété'} required isValid={title.length}>
            <InputText
              id="title"
              value={title}
              maxLength={300}
              placeholder="Veuillez saisir le titre de la propriété"
              onChange={(e) => setTitle(e.target.value)}
            />
          </FormInput>
          <FormInput key="status" label={"Statut de l'évènement"}>
            <Dropdown
              value={isDraft}
              options={CONSTANT.shared.draftTypes}
              optionLabel="label"
              onChange={(e) => setIsDraft(e.value)}
              className="grow"
              valueTemplate={statusTemplate}
              itemTemplate={statusTemplate}
            />
          </FormInput>
          <FormInput
            label={'Département'}
            required
            isValid={dept.length}
            helpMessage="ex: Maine-et-Loire (49)">
            <InputText
              id="dept"
              value={dept}
              maxLength={300}
              placeholder="Veuillez saisir le département"
              onChange={(e) => setDept(e.target.value)}
            />
          </FormInput>
          <FormInput label={'Surface'} required isValid={surface} helpMessage="en hectares">
            <InputNumber
              id="surface"
              value={surface}
              onValueChange={(e) => setSurface(e.value)}
              useGrouping={true}
              placeholder="Veuillez saisir la surface en hectares"
            />
          </FormInput>
          <FormInput label={'Prix'} required isValid={price} helpMessage="en €">
            <InputNumber
              id="price"
              value={price}
              onValueChange={(e) => setPrice(e.value)}
              useGrouping={true}
              placeholder="Veuillez saisir le prix en €"
            />
          </FormInput>
          <FormInput label={'Situation locative'}>
            <ToggleButton
              onLabel="Bien libre"
              offLabel="Bien loué"
              checked={availabilty}
              onChange={(e) => setAvailabilty(e.value)}
            />
          </FormInput>
          <FormInput label={'Statut'}>
            <ToggleButton
              onLabel="Vendu"
              offLabel="Non vendu"
              checked={sold}
              onChange={(e) => setSold(e.value)}
            />
          </FormInput>
          <FormInput key="highlights" label={'Points forts'}>
            <PropertyField
              type={'def_highlights'}
              selectedPropertyList={highlights}
              setSelectedPropertyList={setHighlights}
              scope={'diardexpertise'}
            />
          </FormInput>

          <FormInput label={'Description'} required isValid={description?.length > 3}>
            <RichTextEditor
              value={description}
              onChange={(value) => {
                setDescription(value);
              }}
            />
          </FormInput>
          <ImageForm
            image={mainImg}
            setImage={setMainImg}
            deleteImage={() => setMainImg(undefined)}
            ratio={1.67}
          />
        </div>
        {footerButtons}
      </div>
    </Sidebar>
  );
}

export default PropertyPanel;
